import { passwordCardHeader } from "./password-card-header";
import { passwordCardDeleteModal } from "./password-card-delete-modal";

export const passwordCard = {
	columns: {
		cardOwner: "Dueño de la tarjeta",
		permissions: "Acciones que autoriza",
		cardNumber: "Número de la tarjeta",
		timeCreation: "Fecha/Hora Creación",
		cardCreator: "Creador de la tarjeta",
		cardStatus: "Estado de la tarjeta",
		authorizedTransactioneration: "Operación/Transacción autorizada",
		value: "Valor",
		date: "Fecha/Hora",
		pdvId: "Id del PDV",
		employeeName: "Empleado",
		sourceId: "Id de la transacción",
	},
	statusEmployeeCard: {
		active: "Activo",
		inactive: "Inactivo",
		blocked: "Bloqueado",
	},
	stockHistory: "Historial de acciones",
	blockCard: "Bloquear tarjeta",
	passwordCardHeader,
	passwordCardDeleteModal,
	filename: "historial_de_acciones",
};
